import { IContextualMenuItem } from "@fluentui/react";
import { TSet } from "../constants/types";

export function ExecuteQuery(q : string, apiUrl: string) : Promise<any> {   
    return new Promise((resolve, reject) => {
        fetch(`${apiUrl}/Sql?query=${q}`, {
            method: 'GET',
            mode: 'cors',
        }).then((response) => response.json()).then(response => { 
            console.log(response);
            if (response.IsSuccess) {
                resolve(response.data);
            } else {
                reject(response.Error);
            }
        }).catch( err => {
            reject(err);
        });
    });
}

export class Globals {
  private _searchParams = new URLSearchParams(window.location.search);

  get SearchParams() {
    return this._searchParams;
  }

  GetParam(paramName: string): any {
    return this._searchParams.has(paramName)
  }
}

export default new Globals();

export function ObjectArraysEqual(a1 : any[], a2: any[]) : boolean {
  if (a1.length === a2.length) {
    for (let i=0; i<a1.length; i++) {
      if (ObjectsEqual(a1[i],a2[i]) === false) {
        return false;
      }
    }
    return true;
  } else {
    return false;
  }
}

export const ObjectsEqual = (o1, o2) => 
    typeof o1 === 'object' && o1 !== null && Object.keys(o1).length > 0 
        ? Object.keys(o1).length === Object.keys(o2).length 
            && Object.keys(o1).every(p => ObjectsEqual(o1[p], o2[p]))
        : o1 === o2;

export function SetLoggedOut(apiUrl: string, username: string, token:string) {
  window.location.replace(window.location.origin);
  fetch(`${apiUrl}/Logout?username=${username}&token=${token}`, {
      method: 'GET',
      mode: 'cors',
  });
}

export function GetSets(dev: boolean, selectedSite: string = "pokemoncollectie") : Promise<TSet[]> {
  return new Promise((resolve, reject) => {
    let hostUrl = `https://${selectedSite}.nl/Backend`;
    if (dev) {
        if (selectedSite === "pokemoncollectie") {
          hostUrl = "http://127.0.0.1:7254";
        } else {
          hostUrl = "http://127.0.0.1:7255";
        }
    }

    fetch(`${hostUrl}/sets?onlyAvailable=${false}`, {
        method: 'GET',
    }).then((response) => response.json()).then((data) => {
        let sets = data as TSet[];
        
        resolve(sets);
    }).catch(err => {
        reject(err);
    });
  });
}

export function GetAdress(postalCode: string, houseNumber: string) {
  return fetch(`https://api.pdok.nl/bzk/locatieserver/search/v3_1/free?fq=postcode:${postalCode}&fq=huisnummer=${houseNumber}`)
    .then(response => response.json())
    .then(data => data)
    .catch(error => console.log(error));
}

export function IsNull(obj: any): boolean {
  if (obj === undefined || obj === null || obj === "") {
    return true;
  } else {
    return false;
  }
}

export enum Filters {
  PriceUp = "PriceUp",
  PriceDown = "PriceDown",
  CardNumberUp = "CardNumberUp",
  CardNumberDown = "CardNumberDown"
}

export function CreateSetMenu(sets: TSet[], setid: number, onSetSelectedBaseSet : Function, onSetSelectedSet: Function): IContextualMenuItem[] {
  let basesets: TSet[] = [];
  let expsets: TSet[] = [];

  sets.sort((a, b) => a.name <= b.name ? -1 : 1);

  sets.forEach(set => {
    if (!IsNull(set.parentid) && set.parentid !== 0) {
      expsets.push(set);
    }
  });

  sets.forEach(set => {
    if (IsNull(set.parentid) || set.parentid === 0) {
      basesets.push(set);
    }
  });

  const currentBaseSet = sets.filter(set => set.id === setid)[0];
  let currentexpsets = expsets.filter(set => set.parentid === setid);
  currentexpsets.push(currentBaseSet);

  let menuItems: IContextualMenuItem[] = [];
  basesets.forEach(baseset => {
    let submenuItems: IContextualMenuItem[] = [];
    let subitems = expsets.filter(set => set.parentid === baseset.id);
    subitems.forEach(subitem => {
      let setName = subitem.name;
      if (subitem.cardcount) {
        setName += ` (${subitem.cardcount})`;
      }
      submenuItems.push({
        key: subitem.id.toString(),
        text: setName,
        onClick: () => { onSetSelectedBaseSet(subitem.id); }
      } as IContextualMenuItem);
    });
    if (submenuItems.length) {
      let setName = baseset.name;
      if (baseset.cardcount) {
        setName += ` (${baseset.cardcount})`;
      }
      submenuItems.push({
        key: baseset.id.toString(),
        text: setName,
        onClick: () => { onSetSelectedBaseSet(baseset.id); }
      });
      menuItems.push({
        key: baseset.id.toString() + "_" + baseset.id.toString(),
        text: baseset.name,
        items: submenuItems,
      } as IContextualMenuItem);
    } else {
      let setName = baseset.name;
      if (baseset.cardcount) {
        setName += ` (${baseset.cardcount})`;
      }
      menuItems.push({
        key: baseset.id.toString(),
        text: setName,
        onMouseDown: () => { onSetSelectedBaseSet(baseset.id); }
      } as IContextualMenuItem);
    }
  });

  return menuItems;
}